import React from 'react';
import MuiTextField from '@material-ui/core/TextField';

export interface ITexFieldProps {
  value: string;
  label?: string;
  labelFixed?: boolean;
  onChangeHandler: (val: string) => void;
  onBlurHandler: () => void;
  multiline?: boolean;
  rows?: number;
  placeholder: string;
  outlined?: boolean;
  size?: 'small' | 'medium';
  name: string;
  margin?: 'dense' | 'normal' | 'none';
  error?: any;
  errorText?: any;
  className?: string;
}
const TextField = ({
  value,
  onChangeHandler,
  onBlurHandler,
  label,
  labelFixed,
  multiline,
  rows,
  placeholder,
  outlined,
  size,
  name,
  margin,
  error,
  errorText,
  className,
}: ITexFieldProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeHandler(event.target.value);
  };
  const handleBlur = () => {
    onBlurHandler();
  };
  return (
    <MuiTextField
      name={name}
      id="outlined-multiline-flexible"
      label={label}
      multiline={multiline}
      rows={rows}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      variant={(outlined && 'outlined') || 'standard'}
      placeholder={placeholder}
      size={size}
      margin={margin}
      error={error}
      helperText={errorText}
      InputLabelProps={{ shrink: labelFixed || true }}
      className={className}
    />
  );
};
export default TextField;
